import { Button } from "@mui/material"
import { useState } from "react"
import Iconify from "minimals-template/components/Iconify"
import { confirm } from "lib/@dialogs/confirm"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { Feature } from "lib/@components/feature"
import { resetShareLinkRegimeGatheredData } from "routes/schedule/plugins/share-link-comments/share-link-comments.controller"
import { FEATURE_FLAG_SHARE_LINK_REGIME_RESET } from "routes/schedule/plugins/share-link-comments/feature-flag-share-link-regime-reset"

export function ShareLinkRegimeResetButton({ regimeId, folderId, folderName }) {
    const [resetting, setResetting] = useState(false)

    return (
        <Feature feature={FEATURE_FLAG_SHARE_LINK_REGIME_RESET}>
            <Button
                size="small"
                color="secondary"
                data-cy="share-link-regime-reset"
                disabled={resetting || !regimeId}
                startIcon={<Iconify icon="mdi:backup-restore" />}
                endIcon={getLoadingIcon()}
                onClick={resetGatheredData}
            >
                Reset gathered data
            </Button>
        </Feature>
    )

    async function resetGatheredData() {
        const confirmed = await confirm(getConfirmMessage(), "Reset gathered data")
        if (!confirmed) return
        try {
            setResetting(true)
            const result = await resetShareLinkRegimeGatheredData({ regimeId, folderId })
            successSnackbar(getSuccessMessage(result))
        } catch {
            errorSnackbar("Could not reset gathered data")
        } finally {
            setResetting(false)
        }
    }

    function getConfirmMessage() {
        if (folderId) {
            return `This permanently deletes share-link comments in "${folderName || "this folder"}" and all required-field responses gathered for this regime. This cannot be undone.`
        }
        return "This permanently deletes all share-link comments and required-field responses gathered for this regime and cannot be undone."
    }

    function getSuccessMessage(result) {
        const commentsRemoved = result?.commentsRemoved ?? 0
        const responsesRemoved = result?.responsesRemoved ?? 0
        if (!commentsRemoved && !responsesRemoved) return "Nothing to reset"
        const parts = []
        if (commentsRemoved) parts.push(`${commentsRemoved} comment${commentsRemoved === 1 ? "" : "s"}`)
        if (responsesRemoved) parts.push(`${responsesRemoved} response${responsesRemoved === 1 ? "" : "s"}`)
        return `Removed ${parts.join(" and ")}`
    }

    function getLoadingIcon() {
        if (!resetting) return null
        return <Iconify icon="ic:round-hourglass-empty" className="iconSpin" />
    }
}
